/**************************************************
 * Nombre:       Home_Best_Sellers
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import '@splidejs/react-splide/css';
import {useEffect, useState} from "react";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {TituloTexto} from "./SubComponentes/TituloTexto";
import Tarjeta_Producto_Dos from "../../Tarjetas/Tarjeta_Producto_Dos";

const Home_Best_Sellers = () => {
    const {sCell, masSM} = useResponsive()
    const [prendas, setPrendas] = useState([])


    useEffect(() => {


        setPrendas([])

        let w = [where('masVendido', '==', true), where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'productos', wheres: w}).then((dox) => {
            if (dox.res) {
                setPrendas(dox.data)
            }
        })


    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 3 : 6}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <TituloTexto texto={'NUESTROS'} titulo={'BEST SELLERS'}/>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 10, md: 12}}
                    spacing={4}
                    sx={{mt: 8}}
                >

                    {prendas.length > 0 && prendas.map((it, index) => {
                        return (
                            <Grid container key={index + it.nombre} size={{xs: 6, sm: 6, md: 2.4}}
                                  sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Producto_Dos item={it}/>
                            </Grid>
                        )
                    })}

                </Grid>


            </Grid>


        </Grid>
    )

}
export default Home_Best_Sellers
